export default __webpack_public_path__ + "static/awards-pc-ec-85a2f7e613e484484c55e590bba021e3.png";